var _stop, _stop2, _stop3, _stop4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulingManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "scheduling-management_svg__a_".concat(unique)
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A68FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F94FF",
    offset: "21.055%"
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBEFF",
    offset: "75.824%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFF3",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 2.15H4.333a2.168 2.168 0 00-2.178 2.026l-.005.157v11.334c0 1.164.884 2.099 2.026 2.178l.157.005h11.334a2.168 2.168 0 002.178-2.026l.005-.157V4.333a2.168 2.168 0 00-2.026-2.178l-.157-.005zm0 1.033a1.13 1.13 0 011.143 1.023l.007.127v11.334a1.13 1.13 0 01-1.023 1.143l-.127.007H4.333a1.13 1.13 0 01-1.143-1.023l-.007-.127V4.333A1.13 1.13 0 014.206 3.19l.127-.007h11.334zm-7.5 7.834c-.572 0-1.059.293-1.329.775l-.068.136-.137.089h-.666a.483.483 0 00-.476.397l-.008.086v.033c0 .241.174.436.398.476l.086.008h.666l.137.089a1.5 1.5 0 001.397.91c.571 0 1.058-.292 1.328-.774l.068-.136.137-.09h4.333a.483.483 0 00.476-.397l.008-.086V12.5a.51.51 0 00-.401-.475l-.083-.008H9.7l-.137-.09a1.5 1.5 0 00-1.396-.91zm3.666-5c-.571 0-1.058.293-1.328.775l-.068.136-.137.089H5.967a.483.483 0 00-.476.397l-.008.086v.033c0 .241.174.436.398.476l.086.008H10.3l.137.089a1.5 1.5 0 001.396.91c.572 0 1.059-.292 1.329-.774l.068-.136.137-.09h.666a.483.483 0 00.476-.397l.008-.086V7.5a.51.51 0 00-.401-.475l-.083-.008h-.666l-.137-.09a1.5 1.5 0 00-1.397-.91z",
    fill: "url(#scheduling-management_svg__a_".concat(unique, ")"),
    fillRule: "nonzero"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingManagement);
export default __webpack_public_path__ + "static/assets/scheduling-management.f6f749fc.svg";
export { ForwardRef as ReactComponent };